angular.module('tgaAdmin')
  .service('questionListService', ['$http', 'envService', 'localStorageService', 'domainService',
    function ($http, envService, localStorageService, domainService) {
      const serverAddress = envService.read('serverAddress');

      function getQuestionList(questionListId) {
        return $http({
          method: 'GET',
          url: `${serverAddress}questionlist/${questionListId}`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getQuestionLists() {
        return $http({
          method: 'GET',
          url: `${serverAddress}questionlist`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addQuestionList(data) {
        data.domain = domainService.domain;

        return $http({
          method: 'POST',
          url: `${serverAddress}questionlist`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteQuestionList(questionListId) {
        return $http({
          method: 'DELETE',
          url: `${serverAddress}questionlist/${questionListId}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateQuestionList(data) {
        data.domain = domainService.domain;

        return $http({
          method: 'PUT',
          url: `${serverAddress}questionlist/${data.questionListId}`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addAnswer(data) {
        data.domain = domainService.domain;

        return $http({
          method: 'POST',
          url: `${serverAddress}questionlist/answer`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function uploadJSON(data) {
        data.domain = domainService.domain;

        return $http({
          method: 'POST',
          url: `${serverAddress}questionlist/upload/json`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        getQuestionList,
        getQuestionLists,
        addQuestionList,
        deleteQuestionList,
        updateQuestionList,
        addAnswer,
        uploadJSON,
      });
    }]);
